import React, { useState, useEffect } from "react";
import {
  CRUDLayout,
  DataStatus,
  UpdateButton,
  DeleteButton,
  THead,
  Tr,
  ThFixed,
  Th,
  TBody,
  TdFixed,
  Td,
  ReadButton,
  TableLayout,
  CRUDModalSection,
  CloseButton,
  Alert
} from "components";
import { Form, Formik } from "formik";
import Axios from "axios";
import COATypeApi from "./__COATypeApi__";
import { Content } from "./__COATypeComps__";
import { ModalConfirm } from "components/Modal";
import { formInitialValues, formValidationSchema } from "./_COATypeUtillities__";

export const COATypeList = () => {
  const menuTitle = "CHART OF ACCOUNT TYPE"
  const [listCOAType, setListCOAType] = useState([]);
  const [dropdownGroup, setDropdownGroup] = useState([
    { value: 1, label: "BALANCE SHEET" },
    { value: 2, label: "PROFIT AND LOST" },
  ]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalConfig, setModalConfig] = useState({
    show: false,
    action: "",
    data: {}
  });
  console.log("modal:", modalConfig)

  const getData = () => {
    setIsLoading(true);

    Axios.all([
      COATypeApi.getList(),
      COATypeApi.dropdownCOAGroup()
    ])
      .then(Axios.spread((res, drop) => {
        const group = drop?.data?.payload ? drop?.data?.payload?.map(val => ({ label: val?.group_coa_name, value: val?.group_coa_id })) : []

        setDropdownGroup(group)
        setListCOAType(res?.data?.payload)
      }))
      .catch((err) => alert(err))
      .finally(() => setIsLoading(false));
  };
  useEffect(() => {
    getData();

    return () => setIsLoading(false)
  }, []);

  const CreateModal = () => {
    const submitValidationHandler = (errors) =>
    new Promise((resolve, reject) => {
      const getError = Object.values(errors);

      if (getError.length > 0) {
        reject(getError);
      } else {
        resolve();
      }
    });
    const preSubmitHandler = (formik) => {
      const { values, validateForm, setTouched, setErrors, handleSubmit, setSubmitting } = formik;

      setSubmitting(true);
      validateForm().then(async (err) => {
        setErrors(err);
        setTouched(err);

        await submitValidationHandler(err, values)
          .then(() => handleSubmit())
          .catch((err) => window?.alert("Duplicate Data"))
          .finally(() => setSubmitting(false));
      });
    };
    const formSubmitHandler = (values) => {
      setModalConfig({ ...modalConfig, show: false, action: "CREATE"  })

      COATypeApi.create(values)
        .then(() => setModalConfig({ ...modalConfig, show: true, action: "CREATE_SUCCESS"  }))
        .catch((err) => window?.alert("Duplicate Data"))
        .finally(() => {
          setModalConfig({ ...modalConfig, show: false, action: "CREATE"  })
          getData();
        });
    };

    return (
      <Formik 
        enableReinitialize 
        initialValues={formInitialValues({})} 
        validationSchema={formValidationSchema} 
        onSubmit={(values) => formSubmitHandler(values)}
      >
        {(formik) => (
          <Form>
            <CRUDModalSection
              type="create" 
              title={menuTitle}
              show={Boolean(modalConfig?.show && modalConfig?.action === "CREATE")}
              onHide={() => setModalConfig({ ...modalConfig, show: false, action: "CREATE"  })}
            >
              <Content 
                type="CREATE" 
                dropdownGroup={dropdownGroup} 
                modalConfig={modalConfig} 
                setModalConfig={setModalConfig} 
                onSubmit={() => preSubmitHandler(formik)} 
              />
            </CRUDModalSection>
          </Form>
        )}
      </Formik>
    );
  };
  const UpdateModal = () => {
    const submitValidationHandler = (errors) =>
    new Promise((resolve, reject) => {
      const getError = Object.values(errors);

      if (getError.length > 0) {
        reject(getError);
      } else {
        resolve();
      }
    });
    const preSubmitHandler = (formik) => {
      const { values, validateForm, setTouched, setErrors, handleSubmit, setSubmitting } = formik;

      setSubmitting(true);
      validateForm().then(async (err) => {
        setErrors(err);
        setTouched(err);

        await submitValidationHandler(err, values)
          .then(() => handleSubmit())
          .catch((err) => window?.alert("Duplicate Data"))
          .finally(() => setSubmitting(false));
      });
    };
    const formSubmitHandler = (values) => {
      setModalConfig({ ...modalConfig, show: false, action: "UPDATE"  })

      COATypeApi.update(values, modalConfig?.data?.account_type_id)
        .then(() => setModalConfig({ ...modalConfig, show: true, action: "UPDATE_SUCCESS"  }))
        .catch((err) => window?.alert("Duplicate Data"))
        .finally(() => {
          setModalConfig({ ...modalConfig, show: false, action: "UPDATE"  })
          getData();
        });
    };

    return (
      <Formik 
        enableReinitialize 
        initialValues={formInitialValues(modalConfig?.data)} 
        validationSchema={formValidationSchema} 
        onSubmit={(values) => formSubmitHandler(values)}
      >
        {(formik) => (
          <Form>
            <CRUDModalSection
              type="update" 
              title={menuTitle}
              show={Boolean(modalConfig?.show && modalConfig?.action === "UPDATE")}
              onHide={() => setModalConfig({ ...modalConfig, show: false, action: "UPDATE"  })}
            >
              <Content 
                type="UPDATE" 
                dropdownGroup={dropdownGroup} 
                modalConfig={modalConfig} 
                setModalConfig={setModalConfig} 
                onSubmit={() => preSubmitHandler(formik)} 
              />
            </CRUDModalSection>
          </Form>
        )}
      </Formik>
    );
  };
  const DetailModal = () => {
    return (
      <Formik>
        <CRUDModalSection 
          type={modalConfig?.action}
          title={menuTitle}
          show={Boolean(modalConfig?.show && modalConfig?.action === "READ")}
          onHide={() => setModalConfig({ ...modalConfig, show: false, action: "READ" })}
        >
          <Content action="READ" data={modalConfig?.data} />
          <hr className='my-3'/>
          <div className="mt-3 d-flex">
            <CloseButton icon onClick={() => setModalConfig({ ...modalConfig, show: false, action: "DETAIL"  })} />
          </div>
        </CRUDModalSection>
      </Formik>
    )
  }
  const ConfirmationModal = () => {
    return (
      <ModalConfirm
        type={modalConfig?.action} 
        title={menuTitle}
        show={Boolean(modalConfig?.show && 
          modalConfig?.action === "CREATE_SUCCESS" || modalConfig?.action === "CREATE_ERROR" || 
          modalConfig?.action === "UPDATE_SUCCESS" || modalConfig?.action === "UPDATE_ERROR" || 
          modalConfig?.action === "DELETE_SUCCESS" || modalConfig?.action === "DELETE_ERROR"
        )}
        onHide={() => setModalConfig({ ...modalConfig, show: false, action: modalConfig?.action  })}
      >
        <Content action="READ" data={modalConfig?.data} />
      </ModalConfirm>
    )
  }
  const DeleteModal = () => {
    const deleteDataHandler = () => {
      COATypeApi.delete(modalConfig?.data?.account_type_id)
        .then(() => setModalConfig({ ...modalConfig, show: true, action: "DELETE_SUCCESS"  }))
        .catch((err) => setModalConfig({ ...modalConfig, show: true, action: "DELETE_CONFIRM"}))
        .finally(() => {
          // setModalConfig({ ...modalConfig, show: false, action: "DELETE"  })
          getData();
        });
    };

    return (
      <CRUDModalSection
        type="delete"
        title={menuTitle} 
        show={Boolean(modalConfig?.show && modalConfig?.action === "DELETE")}
        onHide={() => setModalConfig({ ...modalConfig, show: false, action: "DELETE"  })}
      >
        <Content action="READ" data={modalConfig?.data} />

        <Alert textCenter text="Data akan dihapus secara permanen dan tidak dapat dikembalikan !" variant="danger" show={true} />

        <hr className='my-3'/>
        <div className="mt-3 d-flex">
          <CloseButton icon onClick={() => setModalConfig({ ...modalConfig, show: false, action: "UPDATE"  })} />
          <DeleteButton icon forModal label="Delete" onClick={deleteDataHandler} />
        </div>
      </CRUDModalSection>
    );
  };
  const DeleteConfirmModal = () => {
    return (
      <CRUDModalSection
        type="create"
        title={menuTitle} 
        show={Boolean(modalConfig?.show && modalConfig?.action === "DELETE_CONFIRM")}
        onHide={() => setModalConfig({ ...modalConfig, show: false, action: "DELETE_CONFIRM"  })}
      >
        <div className="text-danger">Forbidden deleted, COA type already in used!</div>

        <hr className='my-3'/>
        <div className="mt-3 d-flex">
          <CloseButton icon onClick={() => setModalConfig({ ...modalConfig, show: false, action: "DELETE_CONFIRM"  })} />
        </div>
      </CRUDModalSection>
    );
  };

  const Table = () => {
    return (
      <div className="px-3 pt-3">
        <CRUDLayout.Table>
          <THead>
            <Tr className="text-center">
              <ThFixed>No</ThFixed>
              <ThFixed><div style={{ width: 100 }}>CODE</div></ThFixed>
              <ThFixed><div style={{ width: 300 }}>COA GROUP</div></ThFixed>
              <ThFixed><div style={{ width: 300 }}>ACCOUNT TYPE</div></ThFixed>
              <Th>DESCRIPTION</Th>
              <ThFixed>ACTION</ThFixed>
            </Tr>
          </THead>
          <TBody>
            { listCOAType.length < 0 
              ? <Tr><Td colSpan={6}><div className="text-center">Tidak Ada Data</div></Td></Tr>
              : listCOAType?.map((val, index) => {
              return (
                <Tr key={val.id}>
                  <TdFixed>{index + 1}</TdFixed>
                  <TdFixed>{val?.account_type_code ?? "-"}</TdFixed>
                  <Td>{val?.group_coa_name ?? "-"}</Td>
                  <Td>{val?.account_type_name ?? "-"}</Td>
                  <Td>{val?.description ?? "-"}</Td>
                  <TdFixed >
                    <div className="d-flex">
                      <ReadButton icon onClick={() => setModalConfig({ ...modalConfig, show: true, action: "READ", data: val  })}/>
                      <UpdateButton icon onClick={() => setModalConfig({ ...modalConfig, show: true, action: "UPDATE", data: val  })} />
                      <DeleteButton icon onClick={() => setModalConfig({ ...modalConfig, show: true, action: "DELETE", data: val  })} />
                    </div>
                  </TdFixed>
                </Tr>
              );
            })}
          </TBody>
        </CRUDLayout.Table>
      </div>
    );
  };

  return (
    <CRUDLayout>
      {isLoading 
        ? <DataStatus loading={isLoading} text="Memuat Data" />
        : !Array.isArray(listCOAType)
        ? <DataStatus text="Tidak dapat memuat data" />
        : <TableLayout noMarginTop label={menuTitle} withCreateButton onClick={() => setModalConfig({ ...modalConfig, show: true, action: "CREATE"  })}>
            <Table />
          </TableLayout>
      }

      <CreateModal />
      <UpdateModal />
      <DeleteModal />
      <DeleteConfirmModal />
      <DetailModal />
      {/* <ConfirmationModal /> */}
    </CRUDLayout>
  );
};
